// Product details state

import PatcraftApi from "../../../scripts/patcraft-api";

// Initial state
const state = () => ({
  color: {
    colorNumber: "",
    colorName: "",
    customPdqAvailable: false,
    customInstockAvailable: false,
    samples: [],
    realTimeInventory: null,
    colorVariationLevel: {}
  }, // selected swatch color
  colors: [],
  trustedUser: {},
  roomSceneIndex: 0,
  roomScenes: [],
  categoryName: "General",
  installationMethod: {},
  downloadInstallationMethod: {},
  installationMethods: [],
  coordinatingProducts: [],
  coordinatingProductsFilter: [],
  sellingStyleNumber: "",
  openDownloadFileModal: false,
  productData: [],
  selectedProduct: null,
  productVisualizerURL: "",
  categories: [],
  selectedCoordinatingProductsTab: "Color",
  coordinatingProductsFiltersSelected: {
    price: [],
    productType: {
      Carpet: [],
      Resilient: [],
      Resinous: []
    }
  },
  compareProducts: [],
  isFetchingCoordinatingProducts: false,
  initialLoadCordinatingProducts: true,
  marketSegmentTypes: [],
  fetchingCompareProducts: false,
  visibleThreeDButton: false,
  isOrderSampleEnabled: false,
  ThreeDSourceURL: "",
  ThreeDSourceIcon: "",
  Enable3DSource: false,
  UserGUID: '',
  imperialDisplayValue: '',
  viewOptions: 'swatch',
  compareUrl: '',
  availableSamples: 0,
  vehicleId: ''
});

// Getters
const getters = {
  color: (state, getters, rootState) => {
    return state.color;
  },
  samplesAvailable: (state) => {
    return state.availableSamples;
  },
  getViewOptions: (state, getters, rootState) => {
    return state.viewOptions;
  },
  getImperialDisplayValue: (state) => {
    return state.imperialDisplayValue;
  },
  getTrustedUser: (state, getters, rootState) => {
    return state.trustedUser;
  },
  colors: (state, getters, rootState) => {
    return state.colors;
  },
  categories: (state, getters, rootState) => {
    return state.categories;
  },
  roomSceneIndex: (state, getters, rootState) => {
    return state.roomSceneIndex;
  },
  roomScene: (state, getters, rootState) => {
    if (state.roomScenes) {
      return state.roomScenes[state.roomSceneIndex];
    } else {
      return undefined;
    }
  },
  roomScenes: (state, getters, rootStates) => {
    return state.roomScenes;
  },
  categoryName: (state, getters, rootStates) => {
    return state.categoryName;
  },
  productVisualizerURL: (state, getters, rootState) => {
    return state.productVisualizerURL;
  },
  installationMethod: (state, getters, rootState) => {
    return state.installationMethod;
  },
  getdownloadInstallationMethod: (state) => {
    return state.downloadInstallationMethod;
  },
  installationMethods: (state, getters, rootState) => {
    return state.installationMethods;
  },
  coordinatingProducts: (state, getters, rootState) => {
    return state.coordinatingProducts.SimilarProducts ?? [];
  },
  coordinatingProductsFilters: (state, getters, rootState) => {
    return state.coordinatingProductsFilter;
  },
  selectedCoordinatingProductsTab: (state, getters, rootState) => {
    return {
      currentTab: state.selectedCoordinatingProductsTab,
      flag: state.selectedCoordinatingProductsTab == "Color" ? true : false
    };
  },
  sellingStyleNumber: (state, getters, rootState) => {
    return state.sellingStyleNumber;
  },
  openDownloadFileModal: (state, getters, rootState) => {
    return state.openDownloadFileModal;
  },
  productData: (state, getters, rootState) => {
    return state.productData;
  },
  isComingSoonProduct: (state, getters, rootState) => {
    return state.productData?.specificationCustomData?.isComingSoonProduct;
  },
  customDescription: (state, getters, rootState) => {
    return state.productData?.specificationCustomData?.description;
  },
  keyFeaturesDescription: (state, getters, rootState) => {
    return state.productData?.specificationCustomData?.keyFeaturesDescription;
  },
  selectedProduct: (state, getters, rootState) => {
    return state.selectedProduct;
  },
  rugsSizesOptions: state => {
    return state.productData.groupedProductValues.map(opt => ({
      value: opt.sellingStyleNumber,
      label: `${opt.productSizeImperial} ${opt.shape ?? ""}`
    }));
  },
  isRug: state => {
    return state.productData.inventorySubType.toLowerCase().includes("rug");
  },
  fetchingCoordinatingProducts: (state, getters, rootState) => {
    return state.isFetchingCoordinatingProducts;
  },
  coordinatingProductsFiltersSelected: (state, getters, roomState) => {
    return state.coordinatingProductsFiltersSelected;
  },
  getMarketSegmentTypes: (state, getters) => {
    return state.marketSegmentTypes[0];
  },
  getCompareProducts: (state, getters) => {
    return state.compareProducts;
  },
  fetchingCompareProducts: (state, getters) => {
    return state.fetchingCompareProducts;
  },
  getVisibleThreeDButton: (state, getters) => {
    if (
      state.visibleThreeDButton == "true" ||
      state.visibleThreeDButton == true
    ) {
      return true;
    }
  },
  getEnable3DSource: (state, getters) => {
    if (state.Enable3DSource == "true" || state.Enable3DSource == true) {
      return true;
    }
  },
  getThreeDSourceURL: (state, getters) => {
    return state.ThreeDSourceURL;
  },
  getThreeDSourceIcon: (state, getters) => {
    return state.ThreeDSourceIcon;
  },

  getisOrderSampleEnabled: state => {
    if (state.isOrderSampleEnabled === undefined || state.isOrderSampleEnabled === null) {
      return false;
    }
    if (typeof state.isOrderSampleEnabled === 'boolean') {
      return state.isOrderSampleEnabled;
    }

    if (typeof state.isOrderSampleEnabled === 'string') {
      return state.isOrderSampleEnabled.toLowerCase() === "true";
    }
    return false;
  },
  getCompareUrlLocal: state => {
    return state.compareUrl;
  },

  getUserGUID: state => {
    return state.UserGUID;
  }
};

// Actions
const actions = {
  setColor({ commit, state, dispatch }, color) {
    commit("setColor", { color });
    dispatch("setTrustedUser").then(response => {
      if (state.vehicleId === '') {
        dispatch("setVehicleId", color.samples[0].vehicleId);
      }
      dispatch("setAvailableSamples");
    })
    dispatch("updateCoordinatingProducts", color);
  },
  setVehicleId({ commit }, vehId) {
    commit("setVehicleId", vehId);
  },
  setAvailableSamples({ commit, state }) {
    commit("setAvailableSamples", state.trustedUser?.QuantityInStock[state.vehicleId]);
  },
  async setTrustedUser({ commit, state, dispatch }, color) {
    await PatcraftApi.getTrustedUser(state.productData.sellingStyleNumber, state.productData.inventoryStyleNumber, state.color.colorNumber)
      .then(response => {
        commit("setTrustedUser", response.data);
      })
      .catch(error => { });
  },
  setColors({ commit, state, dispatch }, colors) {
    commit("setColors", { colors });
  },
  setViewOptions({ commit, state, dispatch }, value) {
    commit("setViewOptions", value);
  },
  setCategories({ commit, state }, categories) {
    commit("setCategories", { categories });
  },
  setRoomSceneIndex({ commit, state }, roomSceneIndex) {
    commit("setRoomSceneIndex", { roomSceneIndex });
  },
  setRoomScenes({ commit, state }, roomScenes) {
    commit("setRoomScenes", { roomScenes });
  },
  setCategoryName({ commit, state }, categoryName) {
    commit("setCategoryName", { categoryName });
  },
  setProductVisualizerURL({ commit, state }, productVisualizerURL) {
    commit("setProductVisualizerURL", { productVisualizerURL });
  },
  setInstallationMethod({ commit, state }, installationMethod) {
    commit("setInstallationMethod", { installationMethod });
  },
  setdownloadInstallationMethod({ commit, state }, installationMethod) {
    commit("setdownloadInstallationMethod", { installationMethod });
  },
  setInstallationMethods({ commit, state }, installationMethods) {
    commit("setInstallationMethods", { installationMethods });
  },
  setCoordinatingProducts({ commit, state }, payload) {
    commit("setCoordinatingProducts", payload);
  },

  async marketSegmentType({ commit }) {
    await PatcraftApi.getMarketSegmentTypes()
      .then(response => {
        commit("setMarketSegmentTypes", response);
      })
      .catch(error => { });
  },

  updateCoordinatingProducts({ commit, state }, color) {
    let data = [];
    if (color.colorNumber === "" || state.sellingStyleNumber === "") {
      commit("setCoordinatingProducts", { data });
      return;
    }
    if (
      state.initialLoadCordinatingProducts
      && state.coordinatingProductsFiltersSelected.productType.Carpet.length == 0
      && state.coordinatingProductsFiltersSelected.productType.Resilient.length == 0
    ) {
      state.coordinatingProductsFiltersSelected.productType[
        state.productData.inventoryType.charAt(0).toUpperCase() +
        state.productData.inventoryType.slice(1)
      ].push(state.productData.productTypeDesc.toLowerCase());
      state.initialLoadCordinatingProducts = false;
    }
    commit("fetchingCoordinatingProducts", { status: true });
    PatcraftApi.getCoordinatingProducts(
      state.sellingStyleNumber,
      color.colorNumber,
      state.productData.collection,
      state.selectedCoordinatingProductsTab == "Color" ? 0 : 1,
      state.coordinatingProductsFiltersSelected
    )
      .then(response => {
        data = response.data;
        commit("setCoordinatingProducts", {
          coordinatingProducts: data,
          sellingStyleNumber: null
        });
        // commit("fetchingCoordinatingProducts", { status: false });
      })
      .catch(error => {
        commit("setCoordinatingProducts", {
          coordinatingProducts: [],
          sellingStyleNumber: null
        });
      })
      .finally(() => {
        commit("fetchingCoordinatingProducts", { status: false });
      });
  },
  setCoordinatingProductsTab({ commit, state, dispatch }, value) {
    commit("setCoordinatingProductsTab", { value });
    dispatch("updateCoordinatingProducts", state.color);
  },
  setOpenDownloadFileModal({ commit, state }, openDownloadFileModal) {
    commit("setOpenDownloadFileModal", openDownloadFileModal);
  },
  setSellingStyleNumber({ commit }, value) {
    commit("setSellingStyleNumber", { value });
  },
  setImperialDisplayValue({ commit }, value) {
    commit("setImperialDisplayValue", { value });
  },
  setProductData({ commit, dispatch }, data) {
    commit("setProductData", { data });
    if (data.groupedProductValues.length) {
      const selection =
        data.groupedProductValues.find(
          (prod) => prod.sellingStyleNumber === data.sellingStyleNumber
        ) || {};
      dispatch("setSelectedProduct", selection);
    } else {
      const isResinous = data.productTypeDesc.toLowerCase() === this._vm.$resourceString["productCategory.ResinousFlooring"].toLowerCase();
      const isSheet = (data.productFormDesc || "").toLowerCase() === this._vm.$resourceString["productCategory.Sheet"].toLowerCase()
        || data.productTypeDesc.toLowerCase() === this._vm.$resourceString["productCategory.Sheet"].toLowerCase();
      const prod = {
        sellingStyleNumber: data.sellingStyleNumber,
        pdmsLink: data.pdmsLink,
        construction: data.construction,
        productSizeImperial: isSheet ? data.actualDimensions?.width.imperial.displayValue : isResinous ? "" : data.productSize?.imperialDisplayValue || data.actualDimensions?.imperialDisplayValue || "",
        productSizeMetric: isSheet ? data.actualDimensions?.width.metric.displayValue : isResinous ? "" : data.productSize?.metricDisplayValue || data.actualDimensions?.metricDisplayValue || "",
        imperialDisplaySize: data.imperialDisplaySize || "",
      };
      dispatch("setSelectedProduct", prod);
    }
  },
  setSelectedProduct({ commit, dispatch }, product) {
    commit("setSelectedProduct", { product });
  },
  changeRugsSize({ commit, dispatch, state }, styleNumber) {
    dispatch("setSellingStyleNumber", styleNumber);
    const newSelectedSize =
      state.productData.groupedProductValues.find(
        prod => prod.sellingStyleNumber === styleNumber
      ) || {};
    dispatch("setSelectedProduct", newSelectedSize);
  },
  setRoomsFromCategory({ commit, dispatch, state }, segmentRoomScenesArray) {
    // variable for storing rScenes that match selected category
    let roomSceneIDs = [];

    segmentRoomScenesArray.forEach((element, i) => {
      if (this.categoryName === segmentRoomScenesArray[i].segmentName) {
        roomSceneIDs.push(segmentRoomScenesArray[i].roomScenes.split(","));
      }
    });

    roomSceneIDs = roomSceneIDs[0].map(Number);

    roomSceneIDs = roomSceneIDs.map(id => ({
      data: id,
      type: "interactive"
    }));

    //NEW stored in store array with data: #### type: interactive/static format
    dispatch("setRoomScenes", roomSceneIDs);
  },
  clickCoordinatingFilter(
    { commit, state, dispatch },
    { type, category, inputFilter }
  ) {
    if (inputFilter == "price") {
      if (state.coordinatingProductsFiltersSelected.price?.includes(category)) {
        commit("deselectFilter", { type, category, inputFilter });
      } else {
        commit("selectFilter", { type, category, inputFilter });
      }
    } else {
      if (
        state.coordinatingProductsFiltersSelected.productType[type]?.includes(
          category.toLowerCase()
        )
      ) {
        commit("deselectFilter", { type, category, inputFilter });
      } else {
        commit("selectFilter", { type, category, inputFilter });
      }
    }
    dispatch("updateCoordinatingProducts", state.color);
  },
  initialLoadCompareProducts({ commit }) {
    let compareProducts = ("; " + document.cookie)
      .split(`; compareProducts=`)
      .pop()
      .split(";")[0];
    if (compareProducts != "") {
      PatcraftApi.compareFeature(compareProducts)
        .then(response => {
          response.data.forEach(element => {
            commit("setCompareProducts", element);
          });
        })
        .catch(error => { });
    }
  },
  fetchCompareProducts({ commit, state }, styleNumber) {
    commit("fetchingProducts", true);
    PatcraftApi.compareFeature(styleNumber)
      .then(response => {
        commit("setCompareProducts", response.data[0]);
        commit("fetchingProducts", false);
      })
      .catch(error => { });
  },
  removeCompareProducts({ commit }, styleNumber) {
    commit("removeCompareProduct", styleNumber);
  },
  removeAllCompareProducts({ commit }) {
    commit("removeAllCompareProducts");
  },
  copyCompareUrl({ commit }) {
    commit("copyCompareUrl");
  },
  setCompareUrl({ commit }) {
    commit("setCompareUrl");
  },
  visibleThreeDButton({ commit, dispatch, state }) {
    let data = {
      sellingStyleNumber: state.sellingStyleNumber,
      colorNumber: state.color.colorNumber
    };
    PatcraftApi.getVisibleThreeDButton(data)
      .then(response => {
        data = response.data;
        commit("setThreeButton", data.ThreeDSourceApiResponse);
        commit("setEnable3DSource", data.Enable3DSource);
        commit("setThreeDSourceURL", data.ThreeDSourceRedirectionURL);
        commit("setThreeDSourceIcon", data.ThreeDSourceIcon);
        state.UserGUID = data.UserGUID;
      })
      .catch(error => {
        commit("setThreeButton", false);
      })
      .finally(() => { });
  },
  async isOrderSampleEnabled({ commit }) {
    commit(
      "setIsOrderSampleEnabled",
      this._vm.$cookies.get("ordersamplestatus")
    );
  }
};

// Mutations
const mutations = {
  setMarketSegmentTypes(state, data) {
    state.marketSegmentTypes = data.data;
  },
  setImperialDisplayValue(state, data) {
    state.imperialDisplayValue = data?.value;
  },

  selectFilter(state, { type, category, inputFilter }) {
    if (inputFilter == "price") {
      state.coordinatingProductsFiltersSelected[inputFilter].push(category);
    } else {
      state.coordinatingProductsFiltersSelected[inputFilter][type].push(
        category.toLowerCase()
      );
    }
  },
  setAvailableSamples(state, data) {
    state.availableSamples = data ?? 0;
  },
  setTrustedUser(state, data) {
    state.trustedUser = data;
  },
  setVehicleId(state, data) {
    state.vehicleId = data;
  },
  setViewOptions(state, data) {
    if (["swatch", "multi", "room", "360Video"].includes(data)) {
      state.viewOptions = data;
    }
  },
  deselectFilter(state, { type, category, inputFilter }) {
    if (inputFilter == "price") {
      let removeIndex = state.coordinatingProductsFiltersSelected[
        inputFilter
      ].indexOf(category);
      state.coordinatingProductsFiltersSelected[inputFilter].splice(
        removeIndex,
        1
      );
    } else {
      let removeIndex = state.coordinatingProductsFiltersSelected[inputFilter][
        type
      ].indexOf(category.toLowerCase());
      state.coordinatingProductsFiltersSelected[inputFilter][type].splice(
        removeIndex,
        1
      );
    }
  },
  setColor(state, { color }) {
    state.color = color;
  },
  setColors(state, { colors }) {
    state.colors = colors;
  },
  setRoomSceneIndex(state, { roomSceneIndex }) {
    state.roomSceneIndex = roomSceneIndex;
  },
  setCategories(state, { categories }) {
    state.categories = categories;
  },
  setRoomScenes(state, { roomScenes }) {
    state.roomScenes = roomScenes;
    if (state.roomSceneIndex >= state.roomScenes.length) {
      state.roomSceneIndex = 0;
    }
  },
  setCategoryName(state, { categoryName }) {
    state.categoryName = categoryName;
  },
  setProductVisualizerURL(state, { productVisualizerURL }) {
    state.productVisualizerURL = productVisualizerURL;
  },
  setInstallationMethod(state, { installationMethod }) {
    state.installationMethod = installationMethod;
  },
  setdownloadInstallationMethod(state, { installationMethod }) {
    state.downloadInstallationMethod = installationMethod;
  },
  setInstallationMethods(state, { installationMethods }) {
    state.installationMethods = installationMethods;
  },
  fetchingCoordinatingProducts(state, payload) {
    state.isFetchingCoordinatingProducts = payload.status;
  },
  setCoordinatingProducts(state, payload) {
    if (payload.sellingStyleNumber)
      state.sellingStyleNumber = payload.sellingStyleNumber;
    state.coordinatingProducts = payload.coordinatingProducts;
    if (payload.coordinatingProducts.FilterOptions) {
      state.coordinatingProductsFilter =
        payload.coordinatingProducts.FilterOptions;
    }
  },
  setOpenDownloadFileModal(state, openDownloadFileModal) {
    state.openDownloadFileModal = openDownloadFileModal;
  },
  setSellingStyleNumber(state, { value }) {
    state.sellingStyleNumber = value;
  },
  setProductData(state, { data }) {
    state.productData = data;
  },
  setSelectedProduct(state, { product }) {
    state.selectedProduct = product;
  },
  setCoordinatingProductsTab(state, { value }) {
    state.selectedCoordinatingProductsTab = value;
  },
  setCompareProducts(state, value) {
    value["selectedColor"] = value.colors[0];
    state.compareProducts = [...state.compareProducts, value];
    document.cookie =
      "compareProducts=" +
      state.compareProducts.map(
        ({ sellingStyleNumber }) => sellingStyleNumber
      ) +
      ";path=/";
  },
  fetchingProducts(state, status) {
    state.fetchingCompareProducts = status;
  },
  removeCompareProduct(state, styleNumber) {
    if (state.compareProducts.length == 1) {
      document.cookie = "compareProducts=;path=/";
      state.compareProducts = [];
    } else {
      const result = state.compareProducts.findIndex(
        ({ sellingStyleNumber }) => sellingStyleNumber === styleNumber
      );
      if (result >= 0) {
        let compareProducts = ("; " + document.cookie)
          .split(`; compareProducts=`)
          .pop()
          .split(";")[0]
          .split(",");

        compareProducts.splice(result, 1);

        document.cookie = "compareProducts=" + compareProducts + ";path=/";
        state.compareProducts.splice(result, 1);
      }
    }
  },
  copyCompareUrl(state) {
    navigator.clipboard.writeText(state.compareUrl);
  },
  setCompareUrl(state) {
    let compareProducts = ("; " + document.cookie)
      .split(`; compareProducts=`)
      .pop()
      .split(";")[0];
    const url = new URL(window.location);
    url.searchParams.delete("ProductId");
    url.searchParams.set("CompareProducts", compareProducts);
    state.compareUrl = url.toString();
  },
  removeAllCompareProducts(state) {
    document.cookie = "compareProducts=;path=/";
    state.compareProducts = [];
  },
  setThreeButton(state, value) {
    state.visibleThreeDButton = value;
  },
  setIsOrderSampleEnabled(state, data) {
    state.isOrderSampleEnabled = data;
  },
  setEnable3DSource(state, value) {
    state.Enable3DSource = value;
  },
  setThreeDSourceURL(state, value) {
    state.ThreeDSourceURL = value;
  },
  setThreeDSourceIcon(state, value) {
    state.ThreeDSourceIcon = value;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
